export const PerformanceOverviewEndpoint = {
  GET: '/performance-overview/get',
  GET_COLUMNS: '/performance-overview/get-columns',
  SAVE_COLUMNS_SETTINGS: '/datatable-columns/save-columns',
  SAVE_PAGINATION_SIZE: '/datatable-columns/save-pagination-size',
};
